import React from 'react';
import { HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';

const FaqSection = ({ faqs, expandedFaq, setExpandedFaq }) => (
  <article className="mb-12" aria-labelledby="faq-title">
    <h2 id="faq-title" className="text-2xl font-bold text-white text-center mb-8">
      <HelpCircle className="w-6 h-6 inline mr-2 text-cyan-400" />
      Perguntas Frequentes
    </h2>
    <div className="max-w-3xl mx-auto space-y-4">
      {faqs.map((faq, index) => (
        <div key={index} className="bg-slate-800/60 border border-slate-700/50 rounded-xl overflow-hidden">
          <button onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
            className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-slate-700/30 transition-colors"
            aria-expanded={expandedFaq === index}>
            <span className="text-white font-medium">{faq.question}</span>
            {expandedFaq === index
              ? <ChevronUp className="w-5 h-5 text-cyan-400" />
              : <ChevronDown className="w-5 h-5 text-gray-400" />}
          </button>
          {expandedFaq === index && (
            <div className="px-6 pb-4">
              <p className="text-gray-400">{faq.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  </article>
);

export default FaqSection;
